/* React Component used for the search page */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import CheckTreePicker from 'rsuite/CheckTreePicker';

const fetchInitialItems = () => {
  const topicSelect = document.getElementById('topics__id');
  let initialSelections = [];
  for (let i = 0; i < topicSelect.selectedOptions.length; i++) {
    if (Number(topicSelect.selectedOptions[i].value) !== 0){
      initialSelections.push(Number(topicSelect.selectedOptions[i].value));
    }
  }
  return initialSelections;
};

export default function TopicsWidget(props) {
  const handleUpdate = props.handleUpdate;
  const [options, setOptions] = useState([]);
  const [selections, setSelections] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setOptions([...JSON.parse(document.getElementById('topics-data-json').textContent)]);
    setSelections(fetchInitialItems());
    setIsLoading(false);
  }, []);

  const handleChange = value => {
    setSelections(value);
  };

  const handleExit = () => {
    const topicSelect = document.getElementById('topics__id');
    for (let i = 0; i < topicSelect.options.length; i++) {
          topicSelect.options[i].selected = selections.includes(Number(topicSelect.options[i].value));
    }
    topicSelect.dispatchEvent(new Event("change", { bubbles: true }));
    setTimeout(() => handleUpdate(), 300);
  };

  const handleClean = () => {
    const topicSelect = document.getElementById('topics__id');
    topicSelect.value = 0;
    topicSelect.dispatchEvent(new Event("change", { bubbles: true }));
    setTimeout(() => handleUpdate(), 300);
  };

  if (isLoading) {
    return null;
  }

  return (
    <div className="">
      <CheckTreePicker
        defaultExpandAll={true}
        placeholder="Select..."
        style={{ width: '100%' }}
        data={options}
        size="lg"
        uncheckableItemValues={props.uncheckables}
        disabledItemValues={props.disableItems}
        placement="bottomStart"
        onExit={handleExit}
        onClean={handleClean}
        onChange={(value) => handleChange(value)}
        value={selections}
      />
    </div>
  );
}
/* eslint-enable no-unused-vars */
